import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminMessagingCenter = lazy(() => import("@/pages/admin/AdminMessagingCenter"));

export const Route = createFileRoute("/admin/messaging-center")({
  component: AdminMessagingCenter,
});
